import { BaseWebComponent } from "./webcomponent-base";

export class SidebarNavWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-nav";
    static observedAttributes = [];
    constructor() {
        super();
    }
    render(): void {
        return ; // non c'è niente da renderizzare
    }
}

